 import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function PaymentTable() {
  const data = [
    {
      id: 1,
      invoice: "INV-001",
      client: "Paul Walker",
      role: "CEO",
      company: "Brightway film Industries",
      payment: "Paypal",
      date: "15-12-2025",
    },
    {
      id: 2,
      invoice: "INV-001",
      client: "Paul Walker",
      role: "CEO",
      company: "Brightway film Industries",
      payment: "Paypal",
      date: "15-12-2025",
    },
    {
      id: 3,
      invoice: "INV-001",
      client: "Paul Walker",
      role: "CEO",
      company: "Brightway film Industries",
      payment: "Paypal",
      date: "15-12-2025",
    },
    {
      id: 4,
      invoice: "INV-001",
      client: "Paul Walker",
      role: "CEO",
      company: "Brightway film Industries",
      payment: "Paypal",
      date: "15-12-2025",
    },
    {
      id: 5,
      invoice: "INV-001",
      client: "Paul Walker",
      role: "CEO",
      company: "Brightway film Industries",
      payment: "Paypal",
      date: "15-12-2025",
    },
  ];

  return (
    <div className="container mt-4">
      {/* Header */}
      <div className="row fw-bold text-dark bg-light p-3 rounded shadow-sm mb-3">
        <div className="col">S No.</div>
        <div className="col">Invoice ID</div>
        <div className="col">Client Name</div>
        <div className="col">Company Name</div>
        <div className="col">Payment Type</div>
        <div className="col">Paid Date</div>
      </div>

      {/* Rows */}
      {data.map((item) => (
        <div
          key={item.id}
          className="row align-items-center bg-white p-3 mb-3 rounded shadow-sm"
        >
          <div className="col">{item.id}</div>

          <div className="col fw-semibold text-secondary">
            {item.invoice}
          </div>

          <div className="col">
            <div className="fw-semibold">{item.client}</div>
            <small className="text-muted">{item.role}</small>
          </div>

          <div className="col">
            <div>{item.company}</div>
          </div>

          <div className="col">{item.payment}</div>

          <div className="col fw-semibold">{item.date}</div>
        </div>
      ))}
    </div>
  );
}

export default PaymentTable;